import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal, Form } from 'react-bootstrap';
import './Profile.css';

const Profile = () => {
  const [profile, setProfile] = useState({
    name: 'Authorized Leader',
    email: 'leader@gyandhar.com',
    phone: '+91 98765 43210',
    role: 'Regional Senior Leader',
    joinDate: '2024-01-15',
    avatar: '👨‍💼',
    bio: 'Dedicated leader driving team growth, regional outreach, and active field operations for AWPL.',
    city: 'Patna',
    rank: 'Star Sapphire',
  });

  const [showModal, setShowModal] = useState(false);
  const [editForm, setEditForm] = useState({
    name: profile.name,
    email: profile.email,
    phone: profile.phone,
    bio: profile.bio,
    city: profile.city,
    rank: profile.rank,
  });

  const handleEditClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditForm({
      name: profile.name,
      email: profile.email,
      phone: profile.phone,
      bio: profile.bio,
      city: profile.city,
      rank: profile.rank,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdateProfile = (e) => {
    e.preventDefault();
    setProfile((prev) => ({
      ...prev,
      ...editForm,
    }));
    setShowModal(false);
  };

  return (
    <Container fluid className="profile-page-container">
      {/* Header */}
      <div className="reporting-header-box mb-4">
        <div className="reporting-title-wrap">
          <h2 className="reporting-title">
            <span>👤</span> Account & Leader Profile
          </h2>
          <p className="reporting-subtitle">Manage your personal credentials, contact details, and leadership rank</p>
        </div>
        <div className="reporting-actions-wrap">
          <button className="btn-filter-apply" onClick={handleEditClick}>
            <span>✏️</span> Edit Profile
          </button>
        </div>
      </div>

      <Row className="g-4">
        {/* Left Column: Hero ID Card */}
        <Col xs={12} lg={4}>
          <Card className="profile-hero-card">
            <div className="profile-cover-gradient"></div>
            <Card.Body className="profile-card-body text-center">
              <div className="profile-avatar-wrapper">
                <div className="profile-avatar-circle">{profile.avatar}</div>
              </div>
              <h3 className="profile-display-name">{profile.name}</h3>
              <span className="profile-rank-badge">{profile.rank}</span>
              <p className="profile-bio-text">{profile.bio}</p>

              <div className="profile-stats-grid">
                <div className="profile-stat-box">
                  <span className="profile-stat-val">342</span>
                  <span className="profile-stat-lbl">Lifetime</span>
                </div>
                <div className="profile-stat-box">
                  <span className="profile-stat-val">87</span>
                  <span className="profile-stat-lbl">Month</span>
                </div>
                <div className="profile-stat-box">
                  <span className="profile-stat-val">23</span>
                  <span className="profile-stat-lbl">Week</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Right Column: Detailed Information */}
        <Col xs={12} lg={8}>
          <Card className="profile-details-card">
            <Card.Header className="profile-card-header">
              <h4 className="profile-section-title">
                <span>📋</span> Leadership Credentials
              </h4>
            </Card.Header>
            <Card.Body className="p-4">
              <div className="profile-info-grid">
                <div className="profile-info-item">
                  <span className="info-item-label">Full Name</span>
                  <span className="info-item-value">{profile.name}</span>
                </div>

                <div className="profile-info-item">
                  <span className="info-item-label">Email Address</span>
                  <span className="info-item-value">{profile.email}</span>
                </div>

                <div className="profile-info-item">
                  <span className="info-item-label">Contact Number</span>
                  <span className="info-item-value">{profile.phone}</span>
                </div>

                <div className="profile-info-item">
                  <span className="info-item-label">Assigned Region / City</span>
                  <span className="info-item-value">{profile.city}</span>
                </div>

                <div className="profile-info-item">
                  <span className="info-item-label">Leadership Designation</span>
                  <span className="info-item-value">{profile.role}</span>
                </div>

                <div className="profile-info-item">
                  <span className="info-item-label">Active Since</span>
                  <span className="info-item-value">{profile.joinDate}</span>
                </div>
              </div>

              <hr className="my-4 opacity-25" />

              <div className="security-notice-box">
                <span className="security-icon">🔒</span>
                <div className="security-text">
                  <strong>Two-Factor & Session Security Active</strong>
                  <span>Your account sessions and data entries are authenticated via encrypted tokens.</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Edit Profile Modal */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        centered
        className="detail-modal-custom"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <span>✏️</span> Edit Profile Information
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleUpdateProfile}>
          <Modal.Body className="p-4">
            <Row className="g-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="custom-form-label">Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={editForm.name}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="custom-form-label">Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={editForm.email}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="custom-form-label">Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="phone"
                    value={editForm.phone}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="custom-form-label">City</Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    value={editForm.city}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group>
                  <Form.Label className="custom-form-label">Biography / Role Summary</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="bio"
                    value={editForm.bio}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button variant="primary" type="submit" className="btn-filter-apply">
              Save Changes
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
};

export default Profile;
